export default __webpack_public_path__ + "static/media/Maheshwar_Fort_-_Exterior_01-1024x706.fafdf7a7.jpg";